export default __webpack_public_path__ + "../staticImages/sprite-forecast-wein_service_bonn-2x.png";